import { ICountriesState } from './countries.state';
import { createReducer, on } from '@ngrx/store';
import {
  deleteCountryDocument,
  deleteCountryDocumentFailure,
  deleteCountryDocumentsBulk,
  deleteCountryDocumentsBulkFailure,
  deleteCountryDocumentsBulkSuccess,
  deleteCountryDocumentSuccess,
  loadCountries,
  loadCountriesFailure,
  loadCountriesSuccess,
  loadCountry,
  loadCountryDocumentById,
  loadCountryDocumentByIdFailure,
  loadCountryDocumentByIdSuccess,
  loadCountryDocumentsFailure,
  loadCountryDocumentsSuccess,
  loadCountryFailure,
  loadCountryMessage,
  loadCountryMessageFailure,
  deleteCountryMessage,
  deleteCountryMessageFailure,
  deleteCountryMessagesBulk,
  deleteCountryMessagesBulkFailure,
  deleteCountryMessagesBulkSuccess,
  deleteCountryMessageSuccess,
  loadCountryMessages,
  loadCountryMessagesFailure,
  loadCountryMessagesSuccess,
  loadCountryMessageSuccess,
  loadCountrySuccess,
  loadPaymentDetails,
  loadPaymentDetailsFailure,
  loadPaymentDetailsSuccess,
  resetCountryHelpDocumentFile,
  resetCountryMessage,
  updateCountry,
  updateCountryDocument,
  updateCountryDocumentSuccess,
  updateCountrySuccess,
  updatePaymentDetails,
  updatePaymentDetailsSuccess,
  uploadFile,
} from './countries.actions';

export const initialState: ICountriesState = {
  countryMessages: [],
  messagesLoading: false,
  countryMessage: undefined,
  messageLoading: false,
  countries: [],
  countriesLoading: false,
  country: undefined,
  countryLoading: false,
  countryHelpDocuments: [],
  documentsLoading: false,
  selectedCountryHelpDocument: undefined,
  countryHelpDocumentLoading: false,
  paymentDetails: [],
};

export const countriesReducer = createReducer(
  initialState,
  on(loadCountryMessages, (state) => {
    return {
      ...state,
      messagesLoading: true,
    };
  }),
  on(loadCountryMessagesSuccess, (state, { messages }) => {
    return {
      ...state,
      messagesLoading: false,
      countryMessages: messages,
    };
  }),
  on(loadCountryMessagesFailure, (state) => {
    return {
      ...state,
      messageLoading: false,
    };
  }),
  on(deleteCountryMessage, deleteCountryMessagesBulk, (state) => {
    return {
      ...state,
      messagesLoading: true,
    };
  }),
  on(
    deleteCountryMessageSuccess,
    deleteCountryMessagesBulkSuccess,
    deleteCountryMessageFailure,
    deleteCountryMessagesBulkFailure,
    (state) => {
      return {
        ...state,
        messagesLoading: false,
      };
    }
  ),
  on(loadCountryMessage, (state) => {
    return {
      ...state,
      messageLoading: true,
    };
  }),
  on(loadCountryMessageSuccess, (state, { countryMessage }) => {
    return {
      ...state,
      messageLoading: false,
      countryMessage: countryMessage,
    };
  }),
  on(loadCountryMessageFailure, (state) => {
    return {
      ...state,
      messageLoading: false,
    };
  }),
  on(loadCountries, (state) => {
    return {
      ...state,
      countriesLoading: true,
    };
  }),
  on(loadCountriesSuccess, (state, { countries }) => {
    return {
      ...state,
      countriesLoading: false,
      countries: countries,
    };
  }),
  on(loadCountriesFailure, (state) => {
    return {
      ...state,
      countriesLoading: false,
    };
  }),
  on(loadCountry, (state) => {
    return {
      ...state,
      countryLoading: true,
    };
  }),
  on(loadCountrySuccess, (state, { country }) => {
    return {
      ...state,
      countryLoading: false,
      country: country,
    };
  }),
  on(loadCountryFailure, (state) => {
    return {
      ...state,
      countryLoading: false,
    };
  }),
  on(updateCountry, (state) => {
    return {
      ...state,
      countryLoading: true,
    };
  }),
  on(updateCountrySuccess, (state) => ({
    ...state,
    country: state.country,
    loading: false,
    error: null,
  })),
  on(loadCountryDocumentsSuccess, (state, { documents }) => {
    return {
      ...state,
      documentsLoading: false,
      countryHelpDocuments: documents,
    };
  }),
  on(loadCountryDocumentsFailure, (state) => {
    return {
      ...state,
      documentsLoading: false,
    };
  }),
  on(loadCountryDocumentById, (state) => {
    return {
      ...state,
      countryHelpDocumentLoading: true,
    };
  }),
  on(loadCountryDocumentByIdSuccess, (state, { document }) => {
    return {
      ...state,
      countryHelpDocumentLoading: false,
      selectedCountryHelpDocument: document,
    };
  }),
  on(loadCountryDocumentByIdFailure, (state) => {
    return {
      ...state,
      countryHelpDocumentLoading: false,
    };
  }),
  on(updateCountryDocument, (state) => {
    return {
      ...state,
      countryHelpDocumentLoading: true,
    };
  }),
  on(updateCountryDocumentSuccess, (state) => ({
    ...state,
    selectedCountryHelpDocument: state.selectedCountryHelpDocument,
    countryHelpDocumentLoading: false,
    error: null,
  })),
  on(deleteCountryDocument, (state) => {
    return {
      ...state,
      countryHelpDocumentLoading: true,
    };
  }),
  on(deleteCountryDocumentSuccess, (state) => {
    return {
      ...state,
      countryHelpDocumentLoading: false,
    };
  }),
  on(deleteCountryDocumentFailure, (state) => {
    return {
      ...state,
      countryHelpDocumentLoading: false,
    };
  }),
  on(deleteCountryDocumentsBulk, (state) => {
    return {
      ...state,
      countryHelpDocumentLoading: true,
    };
  }),
  on(deleteCountryDocumentsBulkSuccess, (state, { documentIds }) => {
    return {
      ...state,
      countryHelpDocuments: state.countryHelpDocuments.filter(
        (document) => !documentIds.includes(document.id)
      ),
      countryHelpDocumentLoading: false,
    };
  }),
  on(deleteCountryDocumentsBulkFailure, (state) => {
    return {
      ...state,
      countryHelpDocumentLoading: false,
    };
  }),
  on(uploadFile, (state, { file }) => {
    return {
      ...state,
      file,
    };
  }),
  on(loadPaymentDetails, (state) => {
    return {
      ...state,
    };
  }),
  on(loadPaymentDetailsSuccess, (state, { paymentDetails }) => {
    return {
      ...state,
      paymentDetails: paymentDetails,
    };
  }),
  on(loadPaymentDetailsFailure, (state) => {
    return {
      ...state,
    };
  }),
  on(updatePaymentDetails, (state) => {
    return {
      ...state,
    };
  }),
  on(updatePaymentDetailsSuccess, (state) => ({
    ...state,
    paymentDetails: state.paymentDetails,
    error: null,
  })),
  on(resetCountryMessage, (state) => ({
    ...state,
    countryMessage: undefined,
  })),
  on(resetCountryHelpDocumentFile, (state) => ({
    ...state,
    selectedCountryHelpDocument: undefined,
  }))
);
